import { createAction, DuckSelector, objectDuckCreator } from '@atc/modular-redux';
import { clearActiveExperiments } from '@atc/optimizely-toolkit';

const experimentDuck = objectDuckCreator({
    store: 'experiment',
    initialState: {
        results: [],
        userId: null,
        isLoaded: false,
    },
}).extend({
    types: [
        'SET_EXPERIMENTS',
        'ADD_EXPERIMENT',
        'ADD_EXPERIMENTS',
        'GET_EXPERIMENTS',
        'GET_EXPERIMENT',
        'CLEAR_EXPERIMENTS',
        'SET_LOADED',
    ],

    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.SET_EXPERIMENTS: {
                const { userId, experiments } = action.payload || {};
                return {
                    ...state,
                    results: experiments || [],
                    userId: userId || null,
                    isLoaded: true,
                };
            }

            case types.ADD_EXPERIMENT: {
                const existingExperimentIndex = state.results.findIndex(
                    (experiment) => experiment === action.payload
                );

                const updatedExperiments = [...state.results];
                if (existingExperimentIndex >= 0) {
                    updatedExperiments[existingExperimentIndex] = action.payload;
                } else {
                    updatedExperiments.push(action.payload);
                }

                return {
                    ...state,
                    results: updatedExperiments,
                    isLoaded: true,
                };
            }

            case types.GET_EXPERIMENTS: {
                return [
                    ...state.results,
                ];
            }

            case types.ADD_EXPERIMENTS: {
                const newExperiments = action.payload || [];

                return {
                    ...state,
                    results: [...new Set([...state.results, ...newExperiments])],
                    isLoaded: true,
                };
            }

            case types.CLEAR_EXPERIMENTS: {
                clearActiveExperiments(state.userId);
                return {
                    ...state,
                    results: [],
                    isLoaded: false,
                };
            }

            case types.SET_LOADED: {
                return {
                    ...state,
                    isLoaded: action.payload,
                };
            }

            default:
                return state;
        }
    },

    creators: ({ types }) => ({
        setExperiments: createAction(types.SET_EXPERIMENTS),
        addExperiment: createAction(types.ADD_EXPERIMENT),
        addExperiments: createAction(types.ADD_EXPERIMENTS),
        clearExperiments: createAction(types.CLEAR_EXPERIMENTS),
        setLoaded: createAction(types.SET_LOADED),
    }),

    selectors: () => ({
        getExperiments: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).results),
        getIsLoaded: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).isLoaded),
    }),
});

export default experimentDuck;
